import { ConfirmDialog } from '../../ui/components';

/** Compatibility wrapper while editor call sites migrate to ConfirmDialog directly. */
export default function ConfirmModal({ message, onConfirm, onCancel }) {
  return (
    <ConfirmDialog
      open
      message={message}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
